import Vue from 'vue'

// 小数截取
Vue.filter('floatCutout', num => {
	return num.toFixed(2)
})